import { render, staticRenderFns } from "./add-centre.vue?vue&type=template&id=349cd0a3"
import script from "./add-centre.vue?vue&type=script&lang=js"
export * from "./add-centre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports